<template>
  <vuex-table :fields="fields" table_store="autocaller_v2/campaigns/table">
    <template slot="name" slot-scope="{ item }">
      <router-link
        :to="{ name: 'autocaller_v2.task.index', params: { name: item.name, id: item.id } }"
      >
        {{ item.name }}
      </router-link>
    </template>
    <template slot="active" slot-scope="{ item }">
      <switch-status :id="item.id" :key="item.id" :value="item" />
    </template>
    <template slot="callers" slot-scope="{ item }">
      <callers-info :item="item.callers" />
    </template>
    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <router-link
          tag="span"
          class="dropdown-item-icon dropdown-item-icon--edit"
          :to="{ name: 'autocaller_v2.campaign.edit', params: { id: item.id } }"
        >
          {{ $t('shared.component.table.action.edit') }}
        </router-link>
        <span class="dropdown-item-icon dropdown-item-icon--config" @click="create_task(item.id, item.skills)">
          {{ $t('autocaller_v2.task.button.create') }}
        </span>
        <router-link
          v-if="item.active"
          :to="{ name: 'autocaller_v2.monitoring.index', params: { name: item.name, id: item.id } }"
          class="dropdown-item-icon dropdown-item-icon--config"
          tag="span"
        >
          {{ $t('autocaller_v2.monitoring.button.create') }}
        </router-link>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="add_operators(item.id)">
          {{ $t('autocaller_v2.campaign.field.operators') }}
        </span>
        <span
          v-if="!item.active"
          class="dropdown-item-icon dropdown-item-icon--trash"
          @click="remove(item)"
        >
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import SwitchStatus from './campaigns-editbale-status';
  import CallersInfo from './campaigns-callers-info';
  import { CampaignsModalService } from '@autocaller_v2/modals/CampaignsModalService.js';
  import { TaskModalService } from '@autocaller_v2/modals/TaskModalService';
  import { mapActions } from 'vuex';
  export default {
    components: { SwitchStatus, CallersInfo },
    computed: {
      fields() {
        return [
          {
            key: 'id',
            label: this.$t('autocaller_v2.campaign.field.id'),
            sortable: true
          },
          {
            key: 'name',
            label: this.$t('autocaller_v2.campaign.field.name'),
            sortable: true,
            thStyle: { width: '300px' }
          },
          {
            key: 'active',
            label: this.$t('shared.component.table.field.status'),
            sortable: true
          },
          {
            key: 'type',
            label: this.$t('autocaller_v2.campaign.field.type'),
            sortable: true,
            formatter: (value) => this.$t(`autocaller_v2.campaign.filter.type.${value}`)
          },
          {
            key: 'callers',
            label: this.$t('autocaller_v2.campaign.field.caller_id'),
            sortable: false,
            thStyle: { width: '180px' }
          },
          {
            key: 'updated_at',
            label: this.$t('shared.component.table.field.updated_at'),
            sortable: true,
            thStyle: { width: '150px' }
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            thStyle: { width: '150px' }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '120px' }
          }
        ];
      }
    },
    methods: {
      ...mapActions('autocaller_v2/campaigns/table', ['getAsyncData']),
      ...mapActions('autocaller_v2/campaigns/tasks/table', { getTask: 'getAsyncData' }),
      create_task(id, skills) {
        TaskModalService.create(id, skills).on('success', () => this.getTask());
      },
      add_operators(id) {
        CampaignsModalService.add_operators(id).on('success', () => this.getAsyncData());
      },
      remove(item) {
        CampaignsModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
